import React from 'react';
import { Phone } from 'lucide-react';

const MobileCallButton = () => {
  return (
    <a
      href="tel:+37126590606"
      className="fixed bottom-6 right-6 z-50 md:hidden flex items-center justify-center w-14 h-14 bg-[#8B2942] text-white rounded-full shadow-lg hover:bg-[#6B1F32] active:scale-95 transition-all"
      data-testid="mobile-call-button"
      aria-label="Позвонить"
    >
      <Phone size={24} />
    </a>
  );
};

export default MobileCallButton;
